import { apiClient, APIResponse, PaginatedResponse, QueryOptions } from './client';
import { Component } from './components';
import { LicenseDistribution, VulnerabilityDistribution } from './dashboard';
import { Project } from './projects';

export interface Application {
  id: number;
  workgroupid: number;
  name: string;
  phase?: string;
  applicationtype?: string;
  businesscriticality?: string;
  technology?: string;
  description?: string;
  isfavourite: boolean;
  isarchived: boolean;
  isactive: boolean;
  createdon: string;
  createdby: number;
  lastactivityon?: string;
  lastactivityby?: number;

  creator_firstname?: string;
  creator_lastname?: string;
  creator_emailid?: string;
  creator_designation?: string;
  creator_department?: string;

  project_count?: number;
  active_project_count?: number;
  archived_project_count?: number;

  total_scan_count?: number;
  completed_scan_count?: number;
  pending_scan_count?: number;
  failed_scan_count?: number;
  last_scan_date?: string;
  last_completed_scan_date?: string;

  total_component_count?: number;
  unique_component_count?: number;

  total_vulnerabilities?: number;
  critical_vulnerabilities?: number;
  high_vulnerabilities?: number;
  medium_vulnerabilities?: number;
  low_vulnerabilities?: number;

  total_license_issues?: number;
  critical_license_issues?: number;
  high_license_issues?: number;
  medium_license_issues?: number;
  low_license_issues?: number;

  avg_overall_score?: number;
  avg_vulnerability_score?: number;
  avg_license_score?: number;
  avg_operational_risk_score?: number;
  avg_technical_debt_score?: number;

  risk_level?: string;
  status?: string;
}

export interface CreateApplicationData {
  workgroupid: number;
  name: string;
  phase?: string;
  applicationtype?: string;
  businesscriticality?: string;
  technology?: string;
  description?: string;
  isactive?: boolean;
}

export interface UpdateApplicationData extends Partial<CreateApplicationData> {
  id: number;
  isfavourite?: boolean;
  isarchived?: boolean;
}

export interface ApplicationSecurityMetrics {
  vulnerabilityDistribution: {
    critical: number;
    high: number;
    medium: number;
    low: number;
  };
  licenseRiskDistribution: {
    critical: number;
    high: number;
    medium: number;
    low: number;
  };
  securityScores: {
    overallSecurityScore: number;
    companyRiskScore: number;
    licenseScore: number;
    vulnerabilityScore: number;
    technicalDebtScore: number;
    businessImpactScore: number;
    operationalRiskScore: number;
  } | null;
  componentCount: number;
  scanCount: number;
  lastScanDate?: string;
}

export interface ApplicationRiskAssessment {
  overallRiskLevel: 'Low' | 'Medium' | 'High' | 'Critical';
  vulnerabilityRisk: {
    total: number;
    critical: number;
    high: number;
    medium: number;
    low: number;
  };
  licenseRisk: {
    total: number;
    critical: number;
    high: number;
    medium: number;
    low: number;
  };
  businessImpact: number;
  recommendations: string[];
  trend: Array<{
    date: string;
    overallScore: number;
    vulnerabilityScore: number;
    licenseScore: number;
  }>;
}
export interface ApplicationFilterOptions {
  applicationId?: number;
  projectIds?: number[];
}

export interface ApplicationMetrics {

  totalProjects: number;
  totalScans: number;
  activeScans: number;
  totalVulnerabilities: number;
  criticalVulnerabilities: number;
  totalComponents: number;
  lastScanDate: string;
}
export interface FindApplicationsOptions extends QueryOptions {

}

export class ApplicationAPI {
  static async getAll(options?: FindApplicationsOptions): Promise<APIResponse<PaginatedResponse<Application>>> {
    return apiClient.get<PaginatedResponse<Application>>('/applications', options);
  }


  static async getList(): Promise<APIResponse<Application[]>> {
    return apiClient.get<Application[]>('/applications/findList');
  }
  static async getById(id: number): Promise<APIResponse<Application>> {
    return apiClient.get<Application>(`/applications/${id}`);
  }

  static async create(data: CreateApplicationData): Promise<APIResponse<Application>> {
    return apiClient.post<Application>('/applications', data);
  }

  static async update(id: number, data: UpdateApplicationData): Promise<APIResponse<Application>> {
    return apiClient.patch<Application>(`/applications/${id}`, data);
  }

  static async delete(id: number): Promise<APIResponse<void>> {
    return apiClient.delete<void>(`/applications/${id}`);
  }


  static async archive(id: number): Promise<APIResponse<void>> {
    return apiClient.delete<void>(`/applications/archive/${id}`);
  }

  static async restore(id: number): Promise<APIResponse<void>> {
    return apiClient.patch<void>(`/applications/restore/${id}`);
  }



  static async favourite(id: number, isfavourite: boolean): Promise<APIResponse<void>> {
    return apiClient.patch<void>(`/applications/favourite/${id}/${isfavourite}`);
  }


  static async getProjects(id: number): Promise<APIResponse<Project[]>> {
    return apiClient.get<Project[]>(`/applications/${id}/projects`);
  }


static async getAllComponents(id: number): Promise<APIResponse<Component[]>> {
      return apiClient.get<Component[]>(`/applications/${id}/components`);
    }

}
